import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import styles from '../SaleReportPage.module.scss';
import { buildContactRows } from '../fieldBuilders';

const BuildingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 9h.01" /><path d="M13 9h.01" />
    <path d="M9 13h.01" /><path d="M13 13h.01" />
    <path d="M9 17h.01" /><path d="M13 17h.01" />
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92V21a1 1 0 0 1-1.09 1 19.5 19.5 0 0 1-8.5-3.07 19.2 19.2 0 0 1-6-6A19.5 19.5 0 0 1 3.34 4.42 1 1 0 0 1 4.33 3.3h4.09a1 1 0 0 1 1 .75 11 11 0 0 0 .58 2.4 1 1 0 0 1-.23 1L8.09 9.09a16 16 0 0 0 6.82 6.82l1.64-1.64a1 1 0 0 1 1-.23 11 11 0 0 0 2.4.58 1 1 0 0 1 .75 1z" />
  </svg>
);

function ContactSection({ config, agent, sale, onChange }) {
  const fields = (config && config.fields) || {};

  const setVal = (key, val) => {
    if (onChange) {
      onChange({ ...config, fields: { ...fields, [key + '_edit']: val } });
    }
  };

  const contactData = buildContactRows(agent, sale, config);

  return (
    <>
      {/* 중개사무소 정보 */}
      <div className={styles.section}>
        <SectionHeader
          icon={<BuildingIcon />}
          title="중개사무소 정보"
          locked="필수 영역"
        />
        <div className={styles.grid}>
          {contactData.office.map(({ key, label, value, span, inputType }) => (
            <Field key={key} label={label} span={span} required>
              <input
                type={inputType || 'text'}
                value={value}
                onChange={(e) => setVal(key, e.target.value)}
              />
            </Field>
          ))}
        </div>
      </div>

      {/* 담당자 정보 */}
      <div className={styles.section}>
        <SectionHeader
          icon={<PhoneIcon />}
          title="담당자 정보"
          locked="필수 영역"
        />
        <div className={styles.grid}>
          {contactData.person.map(({ key, label, value, span, inputType }) => (
            <Field key={key} label={label} span={span} required>
              <input
                type={inputType || 'text'}
                value={value}
                onChange={(e) => setVal(key, e.target.value)}
              />
            </Field>
          ))}
        </div>
      </div>
    </>
  );
}

export default ContactSection;
